import { DataModel } from "common/models/utility-models/base-model";

export class AssignmentFilterModel extends DataModel {
    selectedBatch: string = '';
    selectedRegion: string = '';
    selectedLocation: string = '';
    selectedType: string = '';
    selectedStatus: string = '';
    search: string = '';
  }